module.exports = __webpack_public_path__ + "images/marketing/g2-crowd-2016.png";